export default __webpack_public_path__ + "static/IMG_5536-e2f6ab0259cf655be37d05fe4e8e7eac.jpeg";